import React from 'react';
import { CartProvider } from './context/CartContext';
import MarqueeBanner from './components/MarqueeBanner';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ProductSection from './components/ProductSection';
import CreatorBundle from './components/CreatorBundle';
import ReviewsFAQ from './components/ReviewsFAQ';
import Footer from './components/Footer';
import CartDrawer from './components/CartDrawer';
import CheckoutModal from './components/CheckoutModal';

function App() {
  return (
    <CartProvider>
      <div className="min-h-screen bg-zinc-950 font-sans selection:bg-fuchsia-500 selection:text-white">
        <MarqueeBanner />
        <Navbar />
        
        <main>
          <Hero />
          <ProductSection />
          <CreatorBundle />
          <ReviewsFAQ />
        </main>

        <Footer />
        
        {/* Global Overlays */}
        <CartDrawer />
        <CheckoutModal />
      </div>
    </CartProvider>
  );
}

export default App;